export class SortCriterion {
    sort_by:string; // 'created_at'
    sort_order:string; // 'asc'
    default_sort_order:string; // 'desc'
    translationKeyAsc:string; // 'common.first'
    translationKeyDesc:string; // 'common.latest'
  }